import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import { Carousel } from '@gemini/ui';
import Container from '@/components/structure/Container';
import { useTranslation } from '@/hooks/useTranslations';
import { useEditoBgColor, useEditoItems, } from '@/contexts/brandConfiguration/hooks';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import { EditoItem } from './EditoItem';
export const Edito = ({ pageConfiguration, landingType, }) => {
    const { t } = useTranslation();
    const bgColor = useEditoBgColor(pageConfiguration, landingType);
    const items = useEditoItems(pageConfiguration, landingType);
    const locales = `fsrbo.generic.edito`;
    const { isMobile, isTablet } = useBreakpoint();
    const itemsPerView = isMobile ? 1 : isTablet ? 3 : 4;
    const cards = items === null || items === void 0 ? void 0 : items.filter((item) => item.visible === true).map((item, index) => {
        return {
            id: item.url,
            item: (_jsx(EditoItem, { tabIndex: 0, description: t(item.description), img: item.img, url: item.url, marginTop: {
                    'breakpoint.base': 'spacing.none',
                    'breakpoint.md': 'spacing.24',
                } }, `${index}-${item.url}`)),
        };
    });
    return (_jsx(Box, { backgroundColor: bgColor !== null && bgColor !== void 0 ? bgColor : 'color.surface.brand.primary.default', overflowX: "hidden", children: _jsxs(Container, { paddingVertical: {
                'breakpoint.base': 'spacing.32',
                'breakpoint.lg': 'spacing.80',
            }, noContainerTablet: true, children: [!isMobile && (_jsx(Box, { textAlign: "center", typography: {
                        'breakpoint.base': 'typography.headline.24.bold',
                        'breakpoint.lg': 'typography.headline.32.bold',
                    }, marginBottom: "-spacing.40", children: t(`${locales}.title`) })), _jsx(Carousel, { items: cards, itemsPerView: itemsPerView, step: "gradual", arrowPosition: "outside", title: isMobile ? t(`${locales}.title`) : undefined })] }) }));
};
